var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-350b4003.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-42970741.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#9C3900",
      fillRule: "evenodd",
      d: "M25.866 1.333c2.746 1.142 4.147 3.508 4.8 5.069V25.55c-.632 1.544-2.013 3.943-4.755 5.117H10.666V1.333h15.2Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E87E04",
      fillRule: "evenodd",
      d: "M6.088 1.333h3.246v29.334H6.089a7.966 7.966 0 0 1-.756-.372V1.705c.24-.134.491-.259.755-.372Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M5.333 1.705v28.59c-2.245-1.257-3.428-3.349-4-4.744V6.45c.572-1.396 1.755-3.488 4-4.744Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M13 4.667h1v-1a1 1 0 1 0-1 1Zm15.067-1.964c.467.406.868.845 1.212 1.291a1 1 0 0 1-.945.673h-1v-1a1 1 0 0 1 .733-.964ZM13 27.333h1v1a1 1 0 1 1-1-1Zm16.276.666c-.341.448-.74.89-1.205 1.3a1 1 0 0 1-.738-.966v-1h1a1 1 0 0 1 .943.666Zm-11.467-8.823a.667.667 0 0 0-.667-.667h-.36a.615.615 0 0 1-.196-.03c-.45-.152-2.329-.83-2.329-1.608 0-.611.294-1.354.475-1.754a.75.75 0 0 0 .017-.588c-.267-.663-.86-2.267-.721-3.096.084-.506.49-.932.892-1.239.384-.292.877.014.877.496v3.782c0 .168.063.329.176.452l.788.855c.268.292.73.286.992-.012l.177-.203c.272-.31.2-.79-.151-1.007l-1.098-.677v-.517a.5.5 0 0 0 .2-.927l-.2-.118v-.885h1.493c.177 0 .346-.07.471-.195l.494-.494a.667.667 0 0 1 .472-.195h1.053c.267 0 .508.159.613.404l.576 1.347a.667.667 0 0 1-.023.572l-.534 1.016a.667.667 0 0 0 .567.976l2.793.1a.667.667 0 0 0 .412-.125l.205-.146a.667.667 0 0 0-.028-1.103l-.439-.282a.667.667 0 0 0-.36-.106h-.907a.667.667 0 0 1-.666-.666v-.695c0-.25.14-.48.362-.594l.99-.507-.282.644c-.193.44.13.934.611.934h.03a.62.62 0 0 1 .114.01l1.29.222c.157.027.299.11.4.232l.777.941a.645.645 0 0 1 .148.36c.042.518.133 1.905-.018 2.657-.137.688-.549 1.318-.759 1.606a.752.752 0 0 0-.145.37l-.268 2.794a.594.594 0 1 1-1.139-.285l.32-.769a.421.421 0 0 0-.011-.35l-.043-.086c-.188-.376-.755-.242-.755.179 0 .052-.01.104-.031.153l-.537 1.288a.663.663 0 1 1-1.204-.552l.335-.669a.667.667 0 0 0 .07-.298v-.945a.667.667 0 0 0-.667-.667h-2.46a.667.667 0 0 0-.666.667v.945a.667.667 0 0 1-.07.298l-.63 1.26a.667.667 0 0 1-.597.368h-.035a.667.667 0 0 1-.596-.964l.332-.664a.666.666 0 0 0 .07-.298v-.945Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagLka = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagLka_default = SvgFlagLka;
export {
  FlagLka_default as default
};
